import React from "react";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ExportIcon from "../Assets/Images/Sidebar/export_icon.svg";

const ExportToExcel = ({ data, fileName, sheetName,columns }) => {
  const handleExport = () => {
    if (!data || data.length === 0) {
      toast.error("No data available to export!");
      return;
    }

    if (!columns || columns.length === 0) {
      toast.error("No columns specified for export!");
      return;
    }

    // Add Serial Number to data
    // const dataWithSerialNumbers = data.map((item, index) => ({
    //   "Sr. No": index + 1, // Adding serial number field
    //   ...item,
    // }));

    // Map the data to include only specified columns with aliases
    const dataWithSelectedColumns = data.map((item, index) => {
      const mappedItem = { "Sr. No": index + 1 }; // Add serial number
      columns.forEach(({ key, alias }) => {
        mappedItem[alias || key] = item[key] || ""; // Use alias if provided
      });
      return mappedItem;
    });

    // const worksheet = XLSX.utils.json_to_sheet(dataWithSerialNumbers);
    const worksheet = XLSX.utils.json_to_sheet(dataWithSelectedColumns);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName || "Sheet1");
    XLSX.writeFile(workbook, `${fileName || "data"}.xlsx`);

    toast.success("Excel file exported successfully!");
  };

  return (
    // <button onClick={handleExport} className="btn btn-primary">
    //   Export to Excel
    // </button>
    <button className=" d-flex btn m-2 p-2 mt-0 export-btn"
    onClick={handleExport}> 
      <img src={ExportIcon} alt="ExportIcon" className="me-3" />
      Export Report
    </button>
  );
};

export default ExportToExcel;
